module.exports = __webpack_public_path__ + "img/655.b9bc18e2.jpg";